// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__3F5N_","tab":"ProcedureTabs_tab__2nEiR"};